/**
 * Filter operators for search / list API (field:operator:value).
 * Kept aligned with SearchViewLayout getOperatorsForField / default operators.
 */

export function getOperatorsForDataType(dataType) {
  const dt = (dataType || 'text').toLowerCase();

  switch (dt) {
    case 'date':
    case 'datetime':
      return [
        { value: 'equals', label: 'Equals' },
        { value: 'not_equals', label: 'Not Equals' },
        { value: 'greater_than', label: 'Greater Than' },
        { value: 'less_than', label: 'Less Than' },
        { value: 'between', label: 'Between' },
        { value: 'is_null', label: 'Is Null' },
        { value: 'is_not_null', label: 'Is Not Null' }
      ];
    case 'number':
    case 'integer':
    case 'decimal':
    case 'currency':
      return [
        { value: 'equals', label: 'Equals' },
        { value: 'not_equals', label: 'Not Equals' },
        { value: 'greater_than', label: 'Greater Than' },
        { value: 'less_than', label: 'Less Than' },
        { value: 'between', label: 'Between' },
        { value: 'is_null', label: 'Is Null' },
        { value: 'is_not_null', label: 'Is Not Null' }
      ];
    case 'boolean':
    case 'checkbox':
      return [
        { value: 'equals', label: 'Equals' },
        { value: 'is_null', label: 'Is Null' },
        { value: 'is_not_null', label: 'Is Not Null' }
      ];
    default:
      return [
        { value: 'equals', label: 'Equals' },
        { value: 'not_equals', label: 'Not Equals' },
        { value: 'contains', label: 'Contains' },
        { value: 'not_contains', label: 'Not Contains' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is_null', label: 'Is Null' },
        { value: 'is_not_null', label: 'Is Not Null' }
      ];
  }
}

export function defaultOperatorForDataType(dataType) {
  const dt = (dataType || 'text').toLowerCase();
  if (['text', 'phone', 'textarea', 'email', 'url'].includes(dt)) {
    return 'contains';
  }
  if (['picklist', 'multipicklist'].includes(dt)) {
    return 'equals';
  }
  if (['lookup', 'reference'].includes(dt)) {
    return 'equals';
  }
  if (['boolean', 'checkbox'].includes(dt)) {
    return 'equals';
  }
  return 'equals';
}

/** Legacy widget configs omit operator — list API used equals. */
export function effectiveFilterBindingOperator(binding) {
  if (
    binding &&
    binding.operator !== undefined &&
    binding.operator !== null &&
    String(binding.operator).length > 0
  ) {
    return binding.operator;
  }
  return 'equals';
}

/** Bindings persisted on search widgets: include if null-check only or field + source. */
export function isPersistableFilterBinding(b) {
  if (!b?.filterable_field) return false;
  const op = effectiveFilterBindingOperator(b);
  if (op === 'is_null' || op === 'is_not_null') return true;
  return Boolean(b.source_field);
}

export function filterBindingRequiresSourceField(operator) {
  return !['is_null', 'is_not_null'].includes(operator || 'equals');
}
